import { Col, Row } from 'react-bootstrap';
import Wizard from './components/Wizard';

const MemberShip = () => {
  return (
    <div className="container my-auto pt-6">
      <Row className="pt-3 justify-content-center">
        <Col lg={12} xl={12} xxl={9} className="pb-6 text-start">
          <Wizard variant="" />
        </Col>
      </Row>
    </div>
  );
};

export default MemberShip;
